export const CALLS_TYPE = 1
export const CALL_TIME_TYPE = 2
export const INCOMING_CALLS_TYPE = 3
export const INCOMING_CALL_TIME_TYPE = 4
export const EMAILS_TYPE = 5
export const DEMOS_TYPE = 6
export const MEETINGS_TYPE = 7
export const PROSPECTS_TYPE = 8
export const ACCOUNTS_TYPE = 9
export const REFERRALS_TYPE = 10
export const GIVE_UPS_TYPE = 11
export const LONG_CALLS_TYPE = 12

export const activityTypes = [
  CALLS_TYPE,
  CALL_TIME_TYPE,
  INCOMING_CALLS_TYPE,
  INCOMING_CALL_TIME_TYPE,
  EMAILS_TYPE,
  DEMOS_TYPE,
  MEETINGS_TYPE,
  PROSPECTS_TYPE,
  ACCOUNTS_TYPE,
  REFERRALS_TYPE,
  GIVE_UPS_TYPE,
  LONG_CALLS_TYPE,
]

export const mapActivityTypeToProps = (activityType) => {
  switch (activityType) {
    case CALLS_TYPE:
      return 'calls'
    case CALL_TIME_TYPE:
      return 'callTime'
    case INCOMING_CALLS_TYPE:
      return 'incomingCalls'
    case INCOMING_CALL_TIME_TYPE:
      return 'incomingCallTime'
    case EMAILS_TYPE:
      return 'emails'
    case MEETINGS_TYPE:
      return 'meetings'
    case DEMOS_TYPE:
      return 'demos'
    case PROSPECTS_TYPE:
      return 'prospects'
    case ACCOUNTS_TYPE:
      return 'accounts'
    case REFERRALS_TYPE:
      return 'referrals'
    case GIVE_UPS_TYPE:
      return 'giveUps'
    case LONG_CALLS_TYPE:
      return 'longCalls'
    default:
      return ''
  }
}
